import React, { useEffect, useState } from "react";
import { clinicService } from "../../../../services/clinicService";
import { NotificationManager } from "src/util/notify";
import { MaskFormatted } from "../../../../helper/mask-helper";
import { Loader } from "@progress/kendo-react-indicators";

function StripeCustomerInfo({ clinicInfo }) {
  const [stripeCustomerDetail, setStripeCustomerDetail] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (clinicInfo?.field?.stripeCustomerId) {
      getStripeCustomerInfo();
    }
  }, [clinicInfo]);

  const getStripeCustomerInfo = async () => {
    setLoading(true);
    await clinicService
      .getStripeCustomerInfo(clinicInfo?.field?.stripeCustomerId)
      .then((result) => {
        setLoading(false);
        if (result?.resultData) {
          const data = result.resultData;
          setStripeCustomerDetail(data);
        }
      })
      .catch((error) => {
        setLoading(false);
        NotificationManager.error(error?.message);
      });
  };
  return (
    <div className="custom-card bg-white">
      {loading === true && <Loader />}
      {Object.keys(stripeCustomerDetail).length > 0 ? (
        <>
          <h5
            style={{
              fontSize: "20px",
              fontWeight: 500,
              marginBottom: "10px",
              marginTop: "30px",
            }}
          >
            Clinic Stripe Information.
          </h5>

          <h5
            style={{
              fontSize: "16px",
              fontWeight: 500,
              marginBottom: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <i
              className="fa fa-phone"
              aria-hidden="true"
              style={{ marginRight: "8px" }}
            ></i>
            {stripeCustomerDetail?.customerPhone
              ? MaskFormatted(
                  stripeCustomerDetail?.customerPhone,
                  "(999) 999-9999"
                )
              : "N/A"}
          </h5>

          <h5
            style={{
              fontSize: "16px",
              fontWeight: 500,
              marginBottom: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <i
              className="fa fa-envelope"
              aria-hidden="true"
              style={{ marginRight: "8px" }}
            ></i>
            {stripeCustomerDetail?.customerEmail}
          </h5>

          <div className="flex-container">
            <div style={{ flex: 1 }}>
              <span>Customer Stripe ID :</span>
            </div>
            <div style={{ flex: 1 }}>
              <span style={{ fontWeight: "500" }}>
                {stripeCustomerDetail?.stripeCustomerId}
              </span>
            </div>
          </div>

          <div className="flex-container">
            <div style={{ flex: 1 }}>
              <span>Customer Name</span>
            </div>
            <div style={{ flex: 1 }}>
              <span style={{ fontWeight: "500" }}>
                {stripeCustomerDetail?.customerName}
              </span>
            </div>
          </div>
        </>
      ) : (
        <span>
          <strong>Stripe Information for the Clinic is Not Available</strong>
        </span>
      )}
    </div>
  );
}

export default StripeCustomerInfo;
